module.exports = __webpack_public_path__ + "assets/img/1891591928118_.pic_hd.b8d61ab4.jpg";